import { AgentCategory } from "~/shared/enums";
import type { AgentConfig } from "~/shared/types";
import { validateReplicasApiKey, validateReplicasEnvironmentId } from "~/utils/validation";

import AgentIcon from "./AgentIcon.vue";
import Icon from "./Icon.vue";

const config: AgentConfig = {
  name: "Codex via Replicas",
  category: AgentCategory.CODING,
  displayNameOverride: "Codex",
  icon: Icon,
  agentIcon: AgentIcon,
  color: "#988CFF",
  description: "Dispatch complex engineering work to Codex and get GitHub-ready changes back for review",
  descriptionMarkdown: `## Overview

Delegate coding work to OpenAI Codex. Dart starts a run from your task and completes it when Codex opens a pull request. Powered by [Replicas](https://replicas.dev).

## Setup guide

1. Create an account at [replicas.dev](https://replicas.dev) and connect your GitHub repository under [Repository Configuration](https://www.replicas.dev/dashboard?section=platform-github)
2. Configure your Codex credentials in the Replicas dashboard under [Credentials](https://www.replicas.dev/dashboard?section=platform-agents)
3. Upgrade to the Replicas Dev plan and generate an API key from [Platform > API Keys](https://www.replicas.dev/dashboard?section=platform-apikeys)
4. Open [Environments](https://www.replicas.dev/dashboard?section=platform-environment), select your environment, and copy its ID
5. Paste your Replicas API key and environment ID below
6. Assign coding tasks to the Codex agent in Dart`,

  configFields: [
    {
      key: "apiKey",
      type: "password",
      label: "Replicas API key",
      placeholder: "Your Replicas API key",
      validate: validateReplicasApiKey,
    },
    {
      key: "environmentId",
      type: "text",
      label: "Replicas environment ID",
      placeholder: "Your Replicas environment ID",
      validate: validateReplicasEnvironmentId,
    },
  ],
};

export default config;
